import { createRouter, createWebHistory } from 'vue-router';
import { createApp } from 'vue';
import { roleSettingsRoutes } from '@/features/RoleSettings';
import { triggersActionsRoutes } from '@/features/TriggersActions';
import { projectsViewRoute } from '@/router';
import { timesheetSettingsRoutes } from '@/features/TimsheetSettings';
import { mcpServerSettingsRoutes } from '@/features/McpServerSettings';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		...roleSettingsRoutes,
		...triggersActionsRoutes,
		projectsViewRoute,
		...timesheetSettingsRoutes,
		...mcpServerSettingsRoutes,

		// Define a catch-all route to avoid a warning in the console for
		// unmatched routes Add new routes above this one.
		{
			path: '/:pathMatch(.*)*',
			name: 'NotFound',
			component: createApp({}),
		},
	],
});

router.beforeEach((to, from, next) => {
	// Prevent MFE router from handling project view URLs - this may cause
	// unwanted URL overwriting e.g. in Gantt tab
	if (to.name === 'projectsView') {
		next(false);
	} else {
		next();
	}
});

export default router;
